import axios from "axios";
const avatarUrl = 'https://js.devexpress.com/Demos/WidgetsGallery/JSDemos/images/employees/06.png';

const getToken = () => {
  return localStorage.getItem('token');
}

const getUser1 = () => {
  const user = localStorage.getItem('user');
  if (user) {
    return JSON.parse(user);
  }
  return false;
}

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  _user: null,

  loggedIn() {
    return !!getToken();
  },

  async signIn(email, password) {
    try {
      let pendingSelection = null;
      await axios.post('/api/user/login', { email, password }).then((res) => {
        const data = res.data.data;

        if (data.requiresTenantSelection) {
          pendingSelection = { preAuthToken: data.preAuthToken, tenancies: data.tenancies };
          return;
        }

        localStorage.setItem('token', data.accessToken);
        localStorage.setItem('user', JSON.stringify(data.user));
        localStorage.setItem('tenant', JSON.stringify(data.tenant));
        localStorage.setItem('tenantId', JSON.stringify(data.tenant.id));
        localStorage.setItem('role', JSON.stringify(data.roleAbilities));
        localStorage.setItem('menu', JSON.stringify(data.features.menu));
        this._user = { ...data.user, avatarUrl };
      });

      if (pendingSelection) {
        return { isOk: true, requiresTenantSelection: true, ...pendingSelection };
      }
      return { isOk: true, data: this._user };
    }
    catch {
      return {
        isOk: false,
        message: "Authentication failed"
      };
    }
  },

  async selectTenancy(preAuthToken, tenantId) {
    try {
      const res = await axios.post('/api/user/select-tenancy', { preAuthToken, tenantId });
      const data = res.data.data;
      localStorage.setItem('token', data.accessToken);
      localStorage.setItem('user', JSON.stringify(data.user));
      localStorage.setItem('tenant', JSON.stringify(data.tenant));
      localStorage.setItem('tenantId', JSON.stringify(data.tenant.id));
      localStorage.setItem('role', JSON.stringify(data.roleAbilities));
      localStorage.setItem('menu', JSON.stringify(data.features.menu));
      this._user = { ...data.user, avatarUrl };
      return { isOk: true, data: this._user };
    }
    catch {
      return {
        isOk: false,
        message: "Failed to select tenancy. Please try again."
      };
    }
  },

  async getUser() {
    try {
      const user = getUser1();
      if (!user) {
        return {
          isOk: false
        };
      }
      this._user = { ...user, avatarUrl };
      return {
        isOk: true,
        data: this._user
      };
    }
    catch {
      return {
        isOk: false
      };
    }
  },

  async changePassword(password, recoveryCode) {
    try {
      let message, isOk;
      await axios.post('/api/user/set-password', 
      {
        password: password,
        token: recoveryCode
      }).then((res) => {
        message = res.data.message
        isOk = true
      }).catch((er) => {
        if (er && er.response && er.response.data && er.response.data.message){
          message = er.response.data.message
          isOk = false
        }
      });
      return {
        isOk: isOk,
        message: message
      };
    }
    catch {
      return {
        isOk: false,
        message: "Failed to update password"
      }
    }
  },

  async resetPassword(email) {
    try {
      let message, isOk;
      await axios.post('/api/user/forgot-password', { email }).then((res) => {
        message = res.data.message
        isOk = true
      }
      ).catch((er) => {
        if (er && er.response && er.response.data && er.response.data.message){
          message = er.response.data.message
          isOk = false
        }
      });
      return {
        isOk: isOk,
        message: message
      };
    }
    catch(err) {
      return {
        isOk: false,
        message: "Something went wrong. Please try again later."
      };
    }
  },

  async subscribe(firstName, lastName, email, phone) {
    try {
      let message, isOk;
      await axios.post('/api/user/subscribe', { firstName, lastName, email, phone }).then((res) => {
        message = res.data.message
        isOk = true
      }
      ).catch((er) => {
        if (er && er.response && er.response.data && er.response.data.message){
          message = er.response.data.message
          isOk = false
        }
      });
      return {
        isOk: isOk,
        message: message
      };
    }
    catch(err) {
      return {
        isOk: false,
        message: "Something went wrong. Please try again later."
      };
    }
  }

}
